import { render, staticRenderFns } from "./RouterViewComponent.vue?vue&type=template&id=12a8525a&"
import script from "./RouterViewComponent.vue?vue&type=script&lang=js&"
export * from "./RouterViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports